import React, { useState,useContext,useEffect } from 'react';
import { getAuth,signOut } from 'firebase/auth'; 
import { useNavigate,useLocation } from 'react-router-dom';
import LoadingView from 'src/views/auth/LoadingView';
import { doc } from 'firebase/firestore'; 
import { useFirebaseApp } from 'reactfire';
import LogRocket from 'logrocket';

import {
  useUser,
  useFirestoreDocData,
  useFirestore
} from 'reactfire';

export const AuthContext = React.createContext();

export const useAuthContext = ()=>useContext(AuthContext);


export const UserProvider = ({ children }) => {
  const app = useFirebaseApp();
  const auth = getAuth(app);
  const navigate = useNavigate();
  const location = useLocation();

  const [authUndefineCount,setAuthUndefineCount] =useState(0);
  const authData = useUser();
  const user=null;
  const [pending, setPending]= useState(true);
  
  useEffect(()=>{

    // if(authUndefineCount===0){
    //   setAuthUndefineCount(authUndefineCount+1);
    // }
    // else if(authUndefineCount===1){

    if(authData.data){
      setPending(false);

      LogRocket.identify(authData.data.uid, {
        name: authData.data.displayName,
        email: authData.data.email,
      
        // Add your own custom user variables here, ie:
        subscriptionType: 'pro'
      });
    }
  
    else{
      navigate('/login');
      setPending(false);
    }
    // }
  },[authData.data]);
  // console.log('authData.data',authData.data);

  
  const logout = () => {
    return signOut(auth);

  };

  if(pending){
    return <LoadingView />;
  }
  
  if(authData.status==='success'&& authData.data===null&&location.pathname.includes('/app')){
    navigate('/login');
  }


  if(!authData.data){
    return (
      <AuthContext.Provider value={{user, logout}}>
        {children}
      </AuthContext.Provider>
    );
  }
  return (
    <UserComponent authData={authData} logout={logout}>
      {children}
    </UserComponent>
  );
};


const UserComponent = ({authData,logout, children})=>{

  const usersRef = doc(useFirestore(), 'users', authData.data.uid);
  const userData = useFirestoreDocData(usersRef,{idField:'uid'});
  const userId = authData.data.uid;
  const {displayName, photoURL, email, emailVerified, phoneNumber } = authData.data;
  const location = useLocation();

  const [user,setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(()=>{
    const userDataProcess = userData.data ?? {};
    setUser({
      userId, displayName, photoURL, email, emailVerified, phoneNumber, ...userDataProcess
    });
  },[userData]);






  const userLogout = () => {
   
    logout()
      .then(()=>{
        setUser(null);
        navigate('/login');
        window.location.reload();

      });
  };
  if(userData.status ==='loading'){
    return <LoadingView />;
  }
  else if (authData.data !== undefined){
    if(userData.data ===undefined){
      if(location.pathname !=='/welcome'){
        navigate('/welcome');
      }
    }
    else if(userData.data !==undefined &&location.pathname ==='/welcome'){
      navigate('/app/harvesting');
    }
    else if(userData.data !==undefined &&location.pathname ==='/login'){
      navigate('/');
    }
  }
  return (
    <AuthContext.Provider value={{user, logout:userLogout}}>
      {children}
    </AuthContext.Provider>
  );
};